import {ColumnValue, ListDecorator} from './base/ListDecorator';
import {
  SpecFilterExpression,
  SpecFilterUtils,
} from './filters/SpecFilterExpression';
import {POAddress} from '../model/POAddress';
import {of} from 'rxjs';
import {POSite} from '../model/POSite';
import {translate} from '@ngneat/transloco';

export class POSiteListDecorator extends ListDecorator {
  isDelBtn$ = of(true);
  isEditBtn$ = of(true);
  isAddBtn$ = of(true);
  sortIDs = {
    id: true,
    label: true,
  };
  docKey = 'sites';

  constructor() {
    super(POSite.type);

    const {tPrefix} = this;
    const mainTPrefix = `${tPrefix}site.`;
    this.title = `${mainTPrefix}title`;
    const translationFields = [
      'delTitle',
      'oneItemTitle',
      'oneItemNewTitle',
      'oneItemNotFound',
    ];
    this.translateTitleFields(mainTPrefix, translationFields);
    this.headerCaptions$ = of({
      id: translate('ID'),
      label: translate(`${mainTPrefix}label`),
      active: translate(`${tPrefix}header-active`),
      operations: translate(`${tPrefix}header-operations`),
    });
    const headers = ['id', 'label', 'active', 'operations'];
    this.headers$ = of(headers);
  }

  translateFilter(currFilter: string): SpecFilterExpression {
    if (!currFilter?.trim()) {
      return null;
    }

    if (!isNaN(+currFilter)) {
      const num = parseInt(currFilter, null);
      // в строке число
      return SpecFilterUtils.createSimpleExpression(
        SpecFilterExpression.opEq,
        'id',
        num.toString(),
        SpecFilterExpression.typeNumber
      );
    }

    return SpecFilterUtils.createSimpleExpression(
      SpecFilterExpression.opLike,
      'label',
      currFilter,
      SpecFilterExpression.typeString
    );
  }

  translate(property: string, obj: any) {
    if (obj == null) {
      return of(ColumnValue.text(''));
    }

    if (property === 'active') {
      return obj[property]
        ? of(ColumnValue.text('✓'))
        : of(ColumnValue.text(''));
    }

    return super.translate(property, obj);
  }

  toDelMsg(dataItem: POAddress): string[] {
    const {tPrefix} = this;
    const mainTPrefix = `${tPrefix}site.`;
    return [
      translate(`${mainTPrefix}del-msg`),
      translate(`${mainTPrefix}are-u-sure`),
    ];
  }
}
